import { FC } from 'react';
import { LoadingButton } from '@mui/lab';
import clsx from 'clsx';

import './LinearGradientButton.scss';

interface LinearGradientButtonProps {
  children: React.ReactNode;
  disabled?: boolean;
  loading?: boolean;
  onClick: () => void;
  className?: string;
}

const LinearGradientButton: FC<LinearGradientButtonProps> = ({
  children,
  disabled = false,
  loading = false,
  className = '',
  onClick,
  ...props
}) => {
  return (
    <LoadingButton
      disabled={disabled}
      loading={loading}
      className={clsx(`linear-gradient-button`, className)}
      onClick={onClick}
      {...props}
    >
      {children}
    </LoadingButton>
  );
};

export default LinearGradientButton;
